// Tests whether val is an integer, a UUID, an iterable of integers, or an interable of UUIDs
export function isModelId (val) {
  let allValuesAreIntegers = true                                           // Start with true assumption
  if (Array.isArray(val)) {                                                 // If val is an array
    if (!val.length) {                                                      // Handle empty array case (false positive)
      allValuesAreIntegers = false                                          // ..if so, set flag to false
    }
    val.map((v) => {                                                        // Iterate through array...
      if (!Number.isInteger(v) && !isUuid(v)) {                             // ...to see if each value is an ID or UUID
        allValuesAreIntegers = false                                        // If not, set flag to false
      }
    })
    return allValuesAreIntegers
  } else if (val !== null && typeof val === 'object') {                     // If val is an object
    for (let prop in val) {                                                 // Iterate through its properties
      if (!val.hasOwnProperty(prop)) {
        continue
      }
      if (!Number.isInteger(val[prop]) && !isUuid(val[prop])) {             // Check if each prop val is an ID or UUID
        allValuesAreIntegers = false                                        // If not, set flag to false
      }
    }
    return allValuesAreIntegers
  } else {
    if (!Number.isInteger(val) && !isUuid(val)) {                           // If val is not a collection/iterable and also isn't an integer or UUID
      allValuesAreIntegers = false                                          // ...set flag to false
    }
  }
  return allValuesAreIntegers                                               // return flag
}

// Tests if arg is a UUID
export function isUuid (id) {
  if (typeof id !== 'string') {
    return false
  }
  const uuidSegments = id.split('-')
  if (uuidSegments.length !== 5) {
    return false
  }
  let testSegmentLengths = true
  for (let i = 0; i < uuidSegments.length; i++) {
    switch (i) {
      case 0:
        testSegmentLengths = uuidSegments[i].length === 8
        break
      case 1:
      case 2:
      case 3:
        testSegmentLengths = uuidSegments[i].length === 4
        break
      case 5:
        testSegmentLengths = uuidSegments[i].length === 12
    }
  }
  return testSegmentLengths
}
